(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'ReservationAddTravelVendorDetails',
	};

	var $form,
	    reservation_id,
	    selected_vendor  = null;

	var _checkVidantaEligibility,
	    _existingPrimaryRecommendedTravelers,
	    _existingPrimaryClientOpportunities,
	    _existingPrimaryClientSources,
	    _existingPrimaryClientUpcomingReservations,
	    _existingPrimaryClientUpcomingCruiseReservations,
	    _getSailings,
	    _getShips,
	    _newPrimaryRecommendedTraveler,
	    _resetEconnectCruise,
	    _resetVendor,
	    _selectOnQuote,
	    _selectVendor;

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		var $existing_client_id,
		    $existing_client_name,
		    client_opportunity_id;

		$form          = $(form.element);
		reservation_id = $('#reservationaddtravelvendordetails-reservation_id').val();

		Adzuki.Erez.SearchAddTraveler.init(form.name);

		// Do the following if this is for a new reservation
		if (reservation_id === '') {
			// Update recommended travelers when toggling between existing and new primary client
			$form.find('.new-or-existing').on('change', function change(e) {
				if ($(e.target).val() === 'existing') {
					_existingPrimaryRecommendedTravelers();
					_existingPrimaryClientOpportunities();
					_existingPrimaryClientSources();
					_existingPrimaryClientUpcomingReservations();
					_existingPrimaryClientUpcomingCruiseReservations();
				} else {
					_newPrimaryRecommendedTraveler();
				}
			});

			// Update recommended travelers when existing primary client is selected
			$('#reservationaddtravelvendordetails-neworexistingclient-0-existingclient-existing_client_name').on('ta.set-hidden', function setHidden(e) {
				_existingPrimaryRecommendedTravelers();
				_existingPrimaryClientOpportunities();
				_existingPrimaryClientSources();
				_existingPrimaryClientUpcomingReservations();
				_existingPrimaryClientUpcomingCruiseReservations();
			});

			// Update recommended travelers when existing primary client is reset
			$('#reservationaddtravelvendordetails-neworexistingclient-0-existingclient-existing_client_name').on('ta.reset', function reset(e) {
				_existingPrimaryRecommendedTravelers();
				_existingPrimaryClientOpportunities();
				_existingPrimaryClientSources();
				_existingPrimaryClientUpcomingReservations();
				_existingPrimaryClientUpcomingCruiseReservations();
			});

			// Update recommended travelers as first name, last name and DOB are modified
			$('#reservationaddtravelvendordetails-neworexistingclient-0-newclient-new_client_first_name').on('keyup', function keyup(e) {
				_newPrimaryRecommendedTraveler();
			});

			$('#reservationaddtravelvendordetails-neworexistingclient-0-newclient-new_client_last_name').on('keyup', function keyup(e) {
				_newPrimaryRecommendedTraveler();
			});

			$('#reservationaddtravelvendordetails-neworexistingclient-0-newclient-new_client_birthday').on('dp.change', function dateChange(e) {
				_newPrimaryRecommendedTraveler();
			});

			// Toggle warnings depending on which reservation type is selected
			$form.find('#reservationaddtravelvendordetails-type').on('change', function change(e) {
				$form.find('.reservation-type-warning').addClass('hidden');

				if ($(this).val() === 'fam') {
					$form.find('.reservation-type-warning.fam').removeClass('hidden');
				} else if ($(this).val() === 'personal') {
					$form.find('.reservation-type-warning.personal').removeClass('hidden');
				}
			});

			// Toggle client opportunity typeahead
			$form.find('.tie-to-client-opportunity').on('change', function change(e) {
				$form.find('.client-opportunity-fields').toggleClass('hidden');
			});

			// Client opportunity typeahead logic
			Adzuki.Typeahead(
				'#reservationaddtravelvendordetails-client_opportunity_search',
				'/ClientOpportunities/typeaheadSearch',
				function select(item, $self, typeahead) {
					$self.val(item.name);

					typeahead.setHiddenValue(item.id);
				},
				function template(item) {
					return item.name;
				}
			);

			// Client opportunity select logic
			$('#reservationaddtravelvendordetails-client_opportunity_select').on('change', function change(e) {
				client_opportunity_id = this.value;

				$('#reservationaddtravelvendordetails-client_opportunity_id').val(client_opportunity_id);
			});

			// Toggle client opportunity select, search, and new
			// Selecting client opportunity
			$form.find('.select-client-opportunity').on('click', function click(e) {
				e.preventDefault();

				$('#reservationaddtravelvendordetails-client_opportunity_select').val('');

				$form.find('.client-opportunity-search').addClass('hidden');
				$form.find('.client-opportunity-new').addClass('hidden');
				$form.find('.client-opportunity-select').removeClass('hidden');
				$form.find('.client-opportunity').removeClass('hidden');

				$form.find('.client-opportunity-search .reset-typeahead a').trigger('click');
				$('#reservationaddtravelvendordetails-client_opportunity_new').val('');
				$('#reservationaddtravelvendordetails-client_opportunity_link_type').val('select_search');
			});

			// Searching for client opportunity
			$form.find('.search-client-opportunity').on('click', function click(e) {
				e.preventDefault();

				$form.find('.client-opportunity-search .reset-typeahead a').trigger('click');

				$form.find('.client-opportunity-select').addClass('hidden');
				$form.find('.client-opportunity-new').addClass('hidden');
				$form.find('.client-opportunity-search').removeClass('hidden');
				$form.find('.client-opportunity').removeClass('hidden');

				$('#reservationaddtravelvendordetails-client_opportunity_select').val('');
				$('#reservationaddtravelvendordetails-client_opportunity_new').val('');
				$('#reservationaddtravelvendordetails-client_opportunity_link_type').val('select_search');
			});

			// Adding new client opportunity
			$form.find('.new-client-opportunity').on('click', function click(e) {
				e.preventDefault();

				$('#reservationaddtravelvendordetails-client_opportunity_new').val('');

				$form.find('.client-opportunity').addClass('hidden');
				$form.find('.client-opportunity-select').addClass('hidden');
				$form.find('.client-opportunity-search').addClass('hidden');
				$form.find('.client-opportunity-new').removeClass('hidden');

				$form.find('.client-opportunity-search .reset-typeahead a').trigger('click');
				$('#reservationaddtravelvendordetails-client_opportunity_select').val('');
				$('#reservationaddtravelvendordetails-client_opportunity_link_type').val('new');
			});

			// Toggle franchise list select box
			$form.find('.tie-to-franchise-list').on('change', function change(e) {
				$form.find('.franchise-list').toggleClass('hidden');
			});

			// Toggle amex tip code select box
			$form.find('.travel-insider-amex-tip-code').on('change', function change(e) {
				$form.find('.amex-tip-code').toggleClass('hidden');
			});
		}

		// Vendor search typeahead logic
		Adzuki.Typeahead(
			'#reservationaddtravelvendordetails-vendor_search',
			'/Vendors/search',
			function select(item, $self, typeahead) {
				typeahead.setHiddenValue(item.id);
				_selectVendor(item);
				getVendorConfirmationTemplate(item.primary_component_type, item.id);
				$('#reservationaddtravelvendordetails-vendor_id').trigger('change');
			}
		);

		// Vendor select logic
		$('#reservationaddtravelvendordetails-vendor_select').on('change', function change(e) {
			var vendor_id = this.value,
			    type      = $(this).find(':selected').parent().attr('label');

			$('#reservationaddtravelvendordetails-vendor_id').val(vendor_id);

			Adzuki.Ajax.get('/Vendors/getVendor/' + vendor_id).then(function success(vendor) {
				_selectVendor(vendor);
				getVendorConfirmationTemplate(type, vendor_id);
			});
			$('#reservationaddtravelvendordetails-vendor_id').trigger('change');
		});

		// Reset vendor information when vendor typeahead is reset
		$('#reservationaddtravelvendordetails-vendor_search').on('ta.reset', function reset(e) {
			_resetVendor();
		});

		// Toggle vendor search and select
		$form.find('.select-vendor').on('click', function click(e) {
			e.preventDefault();

			$form.find('.vendor-search .reset-typeahead a').trigger('click');

			$form.find('.vendor-search').addClass('hidden');
			$form.find('.vendor-select').removeClass('hidden');
		});

		$form.find('.search-vendor').on('click', function click(e) {
			e.preventDefault();

			$form.find('.vendor-search .reset-typeahead a').trigger('click');

			$form.find('.vendor-search').removeClass('hidden');
			$form.find('.vendor-select').addClass('hidden');

			$('#reservationaddtravelvendordetails-vendor_select').val('');
		});

		// Other vendor JOT form stuff
		$('#reservationaddtravelvendordetails-submit_other_vendor').on('change', function change(e) {
			if ($(this).prop('checked')) {
				window.open('https://form.jotform.com/73364398884171');
			}
		});

		// On Quote select logic
		$form.find('.on-quote-checkbox').on('change', function change(e) {
			_selectOnQuote();
		});

		// Booking method select logic
		$('#reservationaddtravelvendordetails-booking_method').on('change', function change(e) {
			var select = $(this).val();

			$form.find('.confirmation-number').addClass('hidden');
			$form.find('.booking-date').addClass('hidden');
			_resetEconnectCruise();

			switch (select) {
				case 'live':
					if (selected_vendor.primary_component_type === 'cruise') {
						$form.find('.ship').removeClass('hidden');
						$form.find('.sailing').removeClass('hidden');
						$form.find('.final-payment-date').addClass('hidden');
						$form.find('.soft-payment-date').addClass('hidden');
						$form.find('.other-components').addClass('hidden');
						$('.reservation-search-add-traveler').addClass('hidden');
						$('.add-vendor-submit').html('Start Booking Process');

						// ended 12/31/18, leaving in case it comes back
						// if (selected_vendor.primary_component_existing_vendor_id === '3') {
						// 	$form.find('.celebrity-message').removeClass('hidden');
						// }
					}
					break;
				case 'retrieve':
					$form.find('.cruise-retrieval-warning').removeClass('hidden');
					$form.find('.confirmation-number').removeClass('hidden');
					$form.find('.final-payment-date').addClass('hidden');
					$form.find('.soft-payment-date').addClass('hidden');
					$form.find('.other-components').addClass('hidden');
					$('.reservation-search-add-traveler').addClass('hidden');
					$('.add-vendor-submit').html('Retrieve Booking');

					// ended 12/31/18, leaving in case it comes back
					// if (selected_vendor.primary_component_existing_vendor_id === '3') {
					// 	$form.find('.celebrity-message').removeClass('hidden');
					// }
					break;
				default:
					if ($('#reservationaddtravelvendordetails-on_quote-0').prop('checked') === false) {
						$form.find('.confirmation-number').removeClass('hidden');
						$form.find('.booking-date').removeClass('hidden');
					}
					break;
			}
		});

		$('#reservationaddtravelvendordetails-booking_method').data('options', $('#reservationaddtravelvendordetails-booking_method').children());

		$('#reservationaddtravelvendordetails-ship_id').on('change', function change(e) {
			_getSailings($(this).val());
		});

		$('#reservationaddtravelvendordetails-itinerary_id').on('change', function change(e) {
			_checkVidantaEligibility($(this).val());
		});

		$('#reservationaddtravelvendordetails-set_final_payment_date').on('change', function change(e) {
			if ($(this).prop('checked') === true) {
				$form.find('.final-payment-date').removeClass('hidden');
				$form.find('.soft-payment-date').removeClass('hidden');
			} else {
				$form.find('.final-payment-date').addClass('hidden');
				$form.find('.soft-payment-date').addClass('hidden');
			}
		});

		// Auto-adjust final payment soft date when final payment due date is set
		$('#reservationaddtravelvendordetails-final_payment_date').on('dp.change', function dateChange(e) {
			var $soft_payment_date;

			if (e.date === false) {
				return;
			}

			$soft_payment_date = $('#reservationaddtravelvendordetails-soft_payment_date');
			$soft_payment_date.data('DateTimePicker').date(e.date.subtract($soft_payment_date.data('soft-date-days'), 'days'));
		});

		// Submit form when Save and Continue is clicked
		$('.add-vendor-submit').on('click', function click(e) {
			var $target            = $(e.target);

			$('.selected-travelers-box').removeClass('error');
			$target.addClass('disabled');
			$target.next().css('visibility', 'visible');
			$form.submit();
		});

		// Do the following if this is for an existing reservation
		if (reservation_id !== '') {
			Adzuki.Ajax.get('/Reservations/getRecommendedTravelers/reservation/' + reservation_id).then(function success(recommended_travelers) {
				Adzuki.Erez.SearchAddTraveler.buildRecommendedTravelers(recommended_travelers);
			});
		}

		// If a client_id was passed, preset the primary client
		if ($('#reservationaddtravelvendordetails-passed_client_id').val() !== '') {
			$existing_client_id   = $('#reservationaddtravelvendordetails-neworexistingclient-0-existingclient-existing_client_id');
			$existing_client_name = $('#reservationaddtravelvendordetails-neworexistingclient-0-existingclient-existing_client_name');

			$existing_client_id.val($('#reservationaddtravelvendordetails-passed_client_id').val());
			$existing_client_name.val($('#reservationaddtravelvendordetails-passed_client_id').data('client-name'));
			$existing_client_name.attr('disabled', 'disabled');
			$form.find('.existing-client-typeahead-field').find('.reset-typeahead').removeClass('hidden');

			_existingPrimaryRecommendedTravelers();
			_existingPrimaryClientOpportunities();
			_existingPrimaryClientSources();
			_existingPrimaryClientUpcomingReservations();
			_existingPrimaryClientUpcomingCruiseReservations();

			// If a client_opportunity_id was passed it, make sure the hidden and select fields gets set to it
			if ($('#reservationaddtravelvendordetails-passed_client_opportunity_id').val() !== '') {
				client_opportunity_id = $('#reservationaddtravelvendordetails-passed_client_opportunity_id').val();

				$('#reservationaddtravelvendordetails-client_opportunity_id').val(client_opportunity_id);
				$('#reservationaddtravelvendordetails-client_opportunity_select').val(client_opportunity_id);
			}
		}

		if ($('#reservationaddtravelvendordetails-vendor_id').val() !== '') {
			Adzuki.Ajax.get('/Vendors/getVendor/' + $('#reservationaddtravelvendordetails-vendor_id').val()).then(function success(vendor) {
				_selectVendor(vendor);
			});
		}

		// For insurance quote redirection contract
		$('#reservationaddtravelvendordetails-vendor_id').change(function vendorSearchChanged() {
			if ($('#reservationaddtravelvendordetails-reservation_id').val() === '') {

				$('#queue_triggered_emails').removeClass('hidden');

				if ($('#reservationaddtravelvendordetails-allianz_vendor_id').val() === $(this).val()) {
					$('#quote_insurance_section').addClass('hidden');
				} else {
					$('#quote_insurance_section').removeClass('hidden');
				}
			}
		});
	};

	form.success = function success(response)
	{
		var $add_vendor_submit = $('.add-vendor-submit');

		// this is used if a new client is added and the agent entered an email address that is a dupe of another client in their franchise
		if (response['status'] === 'confirmation_prompt') {
			Adzuki.Erez.ClientDuplicateEmail.confirm(response, form.name);

			$add_vendor_submit.next().css('visibility', 'hidden');
			$add_vendor_submit.removeClass('disabled');
			return false;
		}

		if (!Adzuki.Form.hasError(response)) {
			window.location.href = response['data'];
			return true;
		}

		if (response['status'] === 'validation_error') {
			$.each(response['data'], function iterator(i, error_data) {
				if ('errors' in error_data && error_data['errors'][0].substr(0, 19) === 'Selected Travelers ') {
					$('.selected-travelers-box').addClass('error');

					return false;
				}
			});
		}

		$add_vendor_submit.next().css('visibility', 'hidden');
		$add_vendor_submit.removeClass('disabled');

		return false;
	};

	_checkVidantaEligibility = function _checkVidantaEligibility(itinerary_id)
	{
		if (itinerary_id !== null && itinerary_id !== '') {
			Adzuki.Ajax.get('/Itineraries/getVidantaEligibility/' + itinerary_id).then(function success(vidanta_eligibility) {
				if (vidanta_eligibility.eligible === true) {
					$('.vidanta-promo').removeClass('hidden');
				} else {
					$('.vidanta-promo').addClass('hidden');

					$('#reservationaddtravelvendordetails-vidanta_promo').prop('checked', false);
				}
			});
		}
	};

	_existingPrimaryRecommendedTravelers = function _existingPrimaryRecommendedTravelers()
	{
		var client_id = $('#reservationaddtravelvendordetails-neworexistingclient-0-existingclient-existing_client_id').val();

		// eslint-disable-next-line no-negated-condition
		if (client_id !== '') {
			Adzuki.Ajax.get('/Reservations/getRecommendedTravelers/client/' + client_id).then(function success(recommended_travelers) {
				Adzuki.Erez.SearchAddTraveler.buildRecommendedTravelers(recommended_travelers);
			});
		} else {
			Adzuki.Erez.SearchAddTraveler.resetRecommendedTravelers();
		}
	};

	_existingPrimaryClientOpportunities = function _existingPrimaryClientOpportunities()
	{
		var client_id             = $('#reservationaddtravelvendordetails-neworexistingclient-0-existingclient-existing_client_id').val(),
		    client_opportunity_id = $('#reservationaddtravelvendordetails-passed_client_opportunity_id').val(),
		    $client_opportunities = $('#reservationaddtravelvendordetails-client_opportunity_select'),
		    client_opportunity_selected,
		    has_client_opportunities;

		// reset select field
		$client_opportunities.empty();
		$client_opportunities.append($('<option>').text('Choose Sales Opportunity').attr('value', ''));
		$client_opportunities.trigger('change');

		// eslint-disable-next-line no-negated-condition
		if (client_id !== '') {
			has_client_opportunities = false;

			Adzuki.Ajax.get('/ClientOpportunities/getSalesOpportunitiesByClientId/' + client_id + '/both').then(function success(client_opportunities) {
				$.each(client_opportunities, function loadOpportunity(key, client_opportunity) {
					has_client_opportunities    = true;
					client_opportunity_selected = false;

					if (client_opportunity_id === key) {
						client_opportunity_selected = true;
					}

					$client_opportunities.append($('<option>').text(client_opportunity).attr('value', key).attr('selected', client_opportunity_selected));
				});

				// no opportunities for client
				if (has_client_opportunities === false) {
					// so we'll make it so the "new sales opp" field appears if agent links to a sales opp
					$form.find('.client-opportunity').addClass('hidden');
					$form.find('.client-opportunity-select').addClass('hidden');
					$form.find('.client-opportunity-search').addClass('hidden');
					$form.find('.client-opportunity-new').removeClass('hidden');

					$('#reservationaddtravelvendordetails-client_opportunity_link_type').val('new');
				} else {
					// there are opportunities, display the select field
					$form.find('.client-opportunity-search').addClass('hidden');
					$form.find('.client-opportunity-new').addClass('hidden');
					$form.find('.client-opportunity-select').removeClass('hidden');
					$form.find('.client-opportunity').removeClass('hidden');

					$('#reservationaddtravelvendordetails-client_opportunity_link_type').val('select_search');
				}
			});
		} else {
			$('#reservationaddtravelvendordetails-client_opportunity_link_type').val('select_search');

			$form.find('.client-opportunity-search').addClass('hidden');
			$form.find('.client-opportunity-new').addClass('hidden');
			$form.find('.client-opportunity-select').removeClass('hidden');
			$form.find('.client-opportunity').removeClass('hidden');
		}
	};

	_existingPrimaryClientSources = function _existingPrimaryClientSources()
	{
		var client_id = $('#reservationaddtravelvendordetails-neworexistingclient-0-existingclient-existing_client_id').val();

		// eslint-disable-next-line no-negated-condition
		if (client_id !== '') {
			Adzuki.Ajax.get('/Clients/getBasicInfoByClientId/' + client_id).then(function success(client_data) {
				// dev source id = 15583
				// prod source id = 23180
				if (client_data['source_id'] === '15583' || client_data['source_id'] === '23180') {
					$('#reservationaddtravelvendordetails-clublife_booking-0').trigger('click');
				}
			});
		} else {
			// reset invited travel club button
			$('#reservationaddtravelvendordetails-clublife_booking-1').trigger('click');
		}
	};

	_existingPrimaryClientUpcomingReservations = function _existingPrimaryClientUpcomingReservations()
	{
		var client_id               = $('#reservationaddtravelvendordetails-neworexistingclient-0-existingclient-existing_client_id').val(),
		    insurance_quote_checked = $('#reservationaddtravelvendordetails-on_quote-0').prop('checked'),
		    reservation_id          = '';

		$('.client-upcoming-reservations-container').addClass('hidden');
		$('.client-upcoming-reservations').html('');

		if (client_id && insurance_quote_checked) {
			Adzuki.Ajax.get('/Clients/upcomingReservations/' + client_id).then(function success(data) {
				// eslint-disable-next-line no-negated-condition
				if (data !== '') {
					$('.client-upcoming-reservations-container').removeClass('hidden');
				}

				$('.client-upcoming-reservations').html(data);

				$('.reservation-radio').click(function clickRadio() {
					reservation_id = $(this).val();
				});

				$('.quote-insurance-reservation').off().on('click', function clickQuoteButton(e) {
					var quote_link          = '/Reservations/addTravelVendorDetails/',
					    insurance_vendor_id = $(this).data('insurance_vendor_id');

					e.preventDefault();

					quote_link = quote_link + reservation_id + '/vendor_id:' + insurance_vendor_id + '/on_quote:1';

					if (reservation_id === '') {
						Adzuki.StatusMessage('error', 'Please select a reservation to quote insurance for.');
					} else {
						document.location = Adzuki.base_uri + quote_link;
					}
				});
			});
		}
	};

	_existingPrimaryClientUpcomingCruiseReservations = function _existingPrimaryClientUpcomingCruiseReservations()
	{
		var client_id          = $('#reservationaddtravelvendordetails-neworexistingclient-0-existingclient-existing_client_id').val(),
		    reservation_vendor = $('#reservationaddtravelvendordetails-vendor_id').val(),
		    seg_vendor_id      = $('#reservationaddtravelvendordetails-seg_vendor_id').val(),
		    seg_res_id_set     = $('.client-upcoming-cruise-reservations-container').data('seg-res-id-set'),
		    reservation_id     = '';

		$('.client-upcoming-cruise-reservations-container').addClass('hidden');
		$('.client-upcoming-cruise-reservations').html('');

		// hidden reservation_id field was set via upcoming cruise reservation interface, clear it out because vendor was most likely reset
		if (seg_res_id_set === 1) {
			$('#reservationaddtravelvendordetails-reservation_id').val('');
			$('.client-upcoming-cruise-reservations-container').data('seg-res-id-set', '');
		}

		if (client_id && reservation_vendor === seg_vendor_id) {
			Adzuki.Ajax.get('/Clients/upcomingReservations/' + client_id + '/1').then(function success(data) {
				// eslint-disable-next-line no-negated-condition
				if (data !== '') {
					$('.client-upcoming-cruise-reservations-container').removeClass('hidden');
				}

				$('.client-upcoming-cruise-reservations').html(data);

				$('.reservation-radio').click(function clickRadio() {
					reservation_id = $(this).val();

					$('#reservationaddtravelvendordetails-reservation_id').val(reservation_id);
					$('.client-upcoming-cruise-reservations-container').data('seg-res-id-set', 1);
				});
			});
		}
	};

	_getSailings = function _getSailings(ship_id)
	{
		var $sailings = $('#reservationaddtravelvendordetails-itinerary_id'),
		    current_date = new Date(),
		    sailing_date,
		    key_parts,
		    sailing_parts,
		    itinerary_id = null;

		current_date = new Date(current_date.toDateString());

		$sailings.empty();
		$sailings.append($('<option>').text('Choose Sailing').attr('value', ''));
		$sailings.trigger('change');

		if (ship_id === '') {
			return;
		}

		Adzuki.Ajax.get('/CruiseSearch/getSailings/' + ship_id + '/1/1').then(function success(sailings) {
			$.each(sailings, function loadSailing(key, sailing) {
				key_parts = key.split('|');

				$sailings.append($('<option>').text(sailing).attr('value', key_parts[1]));

				if (itinerary_id === null) {
					sailing_parts = sailing.split(' - ');

					sailing_date = new Date(sailing_parts[0]);

					if (sailing_date >= current_date) {
						itinerary_id = key_parts[1];
					}
				}
			});

			if (typeof $sailings.data('selected-id') !== 'undefined') {
				itinerary_id = $sailings.data('selected-id');
				$sailings.removeAttr('data-selected-id');
				$sailings.removeData('selected-id');
			}

			$sailings.val(itinerary_id);

			_checkVidantaEligibility(itinerary_id);
		});
	};

	_getShips = function _getShips(cruise_line_id)
	{
		var $ships    = $('#reservationaddtravelvendordetails-ship_id'),
		    $sailings = $('#reservationaddtravelvendordetails-itinerary_id'),
		    ship_id;

		$ships.empty();
		$ships.append($('<option>').text('Choose Ship').attr('value', ''));
		$ships.trigger('change');

		$sailings.empty();
		$sailings.append($('<option>').text('Choose Sailing').attr('value', ''));
		$sailings.trigger('change');

		Adzuki.Ajax.get('/CruiseSearch/getShips/' + cruise_line_id).then(function success(ships) {
			var sorted_ships = Adzuki.Sort.alphabeticValue(ships);

			$.each(sorted_ships, function loadShip(i, ship) {
				$ships.append($('<option>').text(ship.value).attr('value', ship.key));
			});

			if (typeof $ships.data('selected-id') !== 'undefined') {
				ship_id = $ships.data('selected-id');
				$ships.removeAttr('data-selected-id');
				$ships.removeData('selected-id');

				$ships.val(ship_id);

				$ships.trigger('change');
			}
		});
	};

	_newPrimaryRecommendedTraveler = function _newPrimaryRecommendedTraveler()
	{
		var first_name            = $('#reservationaddtravelvendordetails-neworexistingclient-0-newclient-new_client_first_name').val(),
		    last_name             = $('#reservationaddtravelvendordetails-neworexistingclient-0-newclient-new_client_last_name').val(),
		    date_of_birth         = $('#reservationaddtravelvendordetails-neworexistingclient-0-newclient-new_client_birthday_hidden').val(),
		    recommended_travelers = [],
		    name,
		    dob_moment,
		    now_moment;

		if (first_name !== '' && last_name !== '') {
			name = first_name + ' ' + last_name;

			if (date_of_birth !== '') {
				dob_moment = moment(date_of_birth);
				now_moment = moment();

				name += ' (Age: ' + now_moment.diff(dob_moment, 'years') + ')';
			}

			recommended_travelers[0] = {
				id            : 0,
				name          : name,
				primary_client: 1,
			};

			Adzuki.Erez.SearchAddTraveler.buildRecommendedTravelers(recommended_travelers);
		} else {
			Adzuki.Erez.SearchAddTraveler.resetRecommendedTravelers();
		}
	};

	_resetEconnectCruise = function _resetEconnectCruise()
	{
		$form.find('.ship').addClass('hidden');
		$form.find('.sailing').addClass('hidden');

		if (selected_vendor !== null && selected_vendor.primary_component_final_payment_required) {
			$form.find('.set-final-payment-date').addClass('hidden');
			$form.find('.final-payment-date').removeClass('hidden');
			$form.find('.soft-payment-date').removeClass('hidden');
		} else {
			if (selected_vendor === null || selected_vendor.primary_component_non_final_payment) {
				$form.find('.set-final-payment-date').addClass('hidden');
			} else {
				$form.find('.set-final-payment-date').removeClass('hidden');
			}

			$form.find('.set-final-payment-date').removeClass('hidden');
			$form.find('.final-payment-date').addClass('hidden');
			$form.find('.soft-payment-date').addClass('hidden');
		}

		if (selected_vendor !== null && selected_vendor.other_component_types.length > 0) {
			$form.find('.other-components').removeClass('hidden');
		}

		$form.find('.cruise-retrieval-warning').addClass('hidden');
		// ended 12/31/18, leaving in case it comes back
		// $form.find('.celebrity-message').addClass('hidden');
		$('.reservation-search-add-traveler').removeClass('hidden');
		$('.add-vendor-submit').html('Save and Continue');
	};

	_resetVendor = function _resetVendor()
	{
		selected_vendor  = null;

		$form.find('.other-components').addClass('hidden');
		$form.find('.what-else-package').addClass('hidden');
		$form.find('.what-else-normal').removeClass('hidden');
		$form.find('.vendor-name').html('');
		$form.find('.other-component').addClass('hidden');
		$form.find('.whats-included').addClass('hidden');
		$form.find('.confirmation-number').removeClass('hidden');
		$form.find('.booking-date').removeClass('hidden');
		$form.find('.set-final-payment-date').removeClass('hidden');
		$form.find('.cruise-retrieval-warning').addClass('hidden');
		// ended 12/31/18, leaving in case it comes back
		// $form.find('.celebrity-message').addClass('hidden');

		$('#reservationaddtravelvendordetails-booking_method').empty();
		$('#reservationaddtravelvendordetails-booking_method').append($('#reservationaddtravelvendordetails-booking_method').data('options'));

		_resetEconnectCruise();

		$form.find('.on-quote').addClass('hidden');
		$('#reservationaddtravelvendordetails-on_quote-1').prop('checked', true);
		$('#reservationaddtravelvendordetails-on_quote-1').parent().addClass('active');
		$('#reservationaddtravelvendordetails-on_quote-0').parent().removeClass('active');

		$form.find('.booking-method').addClass('hidden');
		$('#reservationaddtravelvendordetails-booking_method').val('manual');

		$('#reservationaddtravelvendordetails-set_final_payment_date').prop('checked', false);
		$('#reservationaddtravelvendordetails-final_payment_date').data('DateTimePicker').date(null);
		$('#reservationaddtravelvendordetails-soft_payment_date').data('DateTimePicker').date(null);

		$form.find('.vendor-details').addClass('hidden');
		$form.find('.vendor-confirmation-format').html('').addClass('hidden');

		_existingPrimaryClientUpcomingCruiseReservations();
	};

	_selectOnQuote = function _selectOnQuote()
	{
		if ($('#reservationaddtravelvendordetails-on_quote-0').prop('checked')) {
			if (selected_vendor.econnect_booking === '1') {
				$form.find('.booking-method').removeClass('hidden');
				$form.find('.booking-method').find('label').html($form.find('.booking-method').find('label').html().replace('Booking', 'Quoting'));

				// default the quote method to econnect
				$('#reservationaddtravelvendordetails-booking_method').val('live');
			}

			$form.find('.confirmation-number').addClass('hidden');
			$form.find('.booking-date').addClass('hidden');
		} else {
			if (selected_vendor.primary_component_type === 'insurance') {
				$form.find('.booking-method').addClass('hidden');

				// reset the quote method back to manual
				$('#reservationaddtravelvendordetails-booking_method').val('manual');
			}

			$form.find('.booking-method').find('label').html($form.find('.booking-method').find('label').html().replace('Quoting', 'Booking'));

			$form.find('.confirmation-number').removeClass('hidden');
			$form.find('.booking-date').removeClass('hidden');
		}
	};

	_selectVendor = function _selectVendor(vendor)
	{
		var $on_quote           = $form.find('.on-quote'),
		    show_booking_method = false,
		    booking_date,
		    booking_method;

		_resetVendor();

		selected_vendor = vendor;

		$form.find('.vendor-details').removeClass('hidden');

		if (vendor.other === '1') {
			$form.find('.other-vendor-name').removeClass('hidden');
		} else {
			$form.find('.other-vendor-name').addClass('hidden');
		}

		if (vendor.econnect_booking === '1') {
			if (vendor.primary_component_type === 'cruise') {
				_getShips(vendor.primary_component_existing_vendor_id);
			}

			if (vendor.econnect_retrieval === '0') {
				$("#reservationaddtravelvendordetails-booking_method option[value='retrieve']").remove();
			} else {
				show_booking_method = true;
			}

			if (show_booking_method) {
				$form.find('.booking-method').removeClass('hidden');
			}
		}

		if (vendor.primary_component_final_payment_required) {
			if (vendor.primary_component_type === 'air') {
				booking_date = $('#reservationaddtravelvendordetails-booking_date').data('value');

				$('#reservationaddtravelvendordetails-final_payment_date').data('DateTimePicker').date(booking_date);
				$('#reservationaddtravelvendordetails-soft_payment_date').data('DateTimePicker').date(booking_date);
			}

			$form.find('.set-final-payment-date').addClass('hidden');
			$form.find('.final-payment-date').removeClass('hidden');
			$form.find('.soft-payment-date').removeClass('hidden');
		} else {
			if (vendor.primary_component_non_final_payment) {
				$form.find('.set-final-payment-date').addClass('hidden');
			} else {
				$form.find('.set-final-payment-date').removeClass('hidden');
			}

			$form.find('.final-payment-date').addClass('hidden');
			$form.find('.soft-payment-date').addClass('hidden');
		}

		$form.find('.whats-included').addClass('hidden');
		$form.find('.whats-included.' + vendor.primary_component_type).removeClass('hidden');

		if (vendor.other_component_types.length > 0) {
			$form.find('.vendor-name').html(vendor.name_without_type);
			$form.find('.other-components').removeClass('hidden');

			if (vendor.primary_component_type === 'package') {
				$form.find('.what-else-normal').addClass('hidden');
				$form.find('.what-else-package').removeClass('hidden');
			}

			$.each(vendor.other_component_types, function each(key, value) {
				$form.find('.other-component.' + value).removeClass('hidden');
			});
		}

		if (vendor.primary_component_type === 'insurance' && vendor.name.indexOf('Allianz') >= 0) {
			if ($on_quote.data('initial-value') !== undefined && $on_quote.data('initial-value') === 1) {
				$('#reservationaddtravelvendordetails-on_quote-0').prop('checked', true);
				$('#reservationaddtravelvendordetails-on_quote-1').parent().removeClass('active');
				$('#reservationaddtravelvendordetails-on_quote-0').parent().addClass('active');

				$on_quote.removeAttr('data-initial-value');
				$on_quote.removeData('initial-value');
			}

			$on_quote.removeClass('hidden');
		}

		// look for upcoming cruise reservations if SEG is selected vendor
		if (vendor.primary_component_type === 'excursion' && vendor.id === $('#reservationaddtravelvendordetails-seg_vendor_id').val()) {
			_existingPrimaryClientUpcomingCruiseReservations();
		}

		_selectOnQuote();

		if (typeof $('#reservationaddtravelvendordetails-booking_method').data('selected-method') !== 'undefined') {
			booking_method = $('#reservationaddtravelvendordetails-booking_method').data('selected-method');
			$('#reservationaddtravelvendordetails-booking_method').removeAttr('data-selected-method');
			$('#reservationaddtravelvendordetails-booking_method').removeData('selected-method');

			$('#reservationaddtravelvendordetails-booking_method').val(booking_method);

			$('#reservationaddtravelvendordetails-booking_method').trigger('change');
		}
	};

	function getVendorConfirmationTemplate(vendor_type, vendor_id)
	{
		var _vendor_type = vendor_type;

		if (_vendor_type === 'Car Rental') {
			_vendor_type = 'car';
		} else if (_vendor_type === 'Package') {
			_vendor_type = 'tour/package';
		}

		Adzuki.Ajax.get('/Vendors/getVendorConfirmationFormat/'+_vendor_type+'/'+vendor_id)
		.then(function getVendorTemplate(data) {
			var html = [],
			    type;

			if (!data.status) {
				return;
			}

			html.push('<p>');
			for (type in data.formats) {
				if (!Object.prototype.hasOwnProperty.call(data.formats, type)) {
					continue;
				}

				if (type === 'other') {
					html.push('<b>Confirmation Number Format:</b><br>');
				} else {
					html.push('<b>'+Adzuki.String.ucwords(type)+' Reservations:</b><br>');
				}

				data.formats[type].forEach(function confTemplate(template) {
					html.push(template.format+' (ex. '+template.example+')<br>');
				});
			}
			html.push('</p>');

			$('.vendor-confirmation-format').html(html.join('')).removeClass('hidden');
		});
	}

}(jQuery, window.Adzuki || {}));
